import { LABEL_FONT_SIZE } from '../types/default.js';

type LabelPositionProps = {
  outerRadius: number;
  innerRadius: number;
  centroidX: number;
  centroidY: number;
};

/**
 * Calculates the X and Y position of the label in relation to the radius and centroids that are given (midpoint between the inner and outer radius).
 *
 * It gets the centroids (x and y) default label position. And also gets the centroid position as radius distance.
 * It then calculates how far the current centroids are percentually, in relation to the desired radius position (e.g. it is 55% away from reaching the expected 100% radius position).
 *
 * Then it returns what this 100% value would be for the centroids (positon x and y for the desired radius distance).
 *
 * @param values - props needed to calculate the position of the element. The centroids and the inner and outer radius.
 * @returns X and Y positions for the label
 */
export const labelPosition = ({
  outerRadius,
  innerRadius,
  centroidX,
  centroidY,
}: LabelPositionProps) => {
  const labelRadiusDistance = outerRadius + LABEL_FONT_SIZE / 2;
  const distanceAsPercentage =
    // radius centroid / radius expected positon === centroid in percentage
    (outerRadius + innerRadius) / (2 * labelRadiusDistance);

  return {
    // expand centroids X and Y proportionally so they expand up to the desired radius distance
    labelX: centroidX * (1 / distanceAsPercentage),
    labelY: centroidY * (1 / distanceAsPercentage),
  };
};
